export default "__VITE_ASSET__CtI3afJu__"